import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function RevealSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#F3EDF7] py-20 md:py-28 relative overflow-hidden" data-id="element-163">
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-[#B794C0] rounded-full opacity-10" data-id="element-164" />
      <div className="absolute bottom-20 right-10 w-48 h-48 bg-[#E07A5F] rounded-full opacity-10" data-id="element-165" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-167">
          <span className="inline-block bg-[#B794C0] text-white text-sm font-semibold px-4 py-2 rounded-full mb-6" data-id="element-168">
            LA REVELACIÓN
          </span>

          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] leading-tight" data-id="element-169">
            Para trabajar con hijos en casa, no necesitas "organizarte mejor".
          </h2>

          <p className="font-['Playfair_Display'] text-2xl md:text-3xl text-[#B794C0] mt-4" data-id="element-170">
            Necesitas un Sistema de Interrupción Cero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-171">
          <p className="text-lg md:text-xl text-[#4A4A4A] leading-relaxed mb-6" data-id="element-172">
            La mayoría de los consejos de productividad te dicen: "Levántate a
            las 5 AM" o "Trabaja cuando duerman". Pero, ¿qué pasa cuando ya
            estás agotada para madrugar? ¿O cuando las siestas son
            impredecibles?
          </p>

          <div className="bg-[#FDF8F3] rounded-2xl p-6 md:p-8" data-id="element-173">
            <p className="text-lg md:text-xl text-[#2D2D2D] leading-relaxed" data-id="element-174">
              Ahí es donde entra el{' '}
              <strong className="text-[#B794C0]" data-id="element-175">
                Método BAD (Bloques de Alta Densidad)
              </strong>
              .
            </p>

            <p className="text-lg md:text-xl text-[#4A4A4A] leading-relaxed mt-4" data-id="element-176">
              Este sistema está basado en la psicología del niño y la realidad
              de una madre emprendedora. Se trata de aprender a trabajar{' '}
              <em data-id="element-177">con</em> la ventana de atención de tus hijos,
              <strong data-id="element-178"> no en su contra</strong>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}